import { getPlayerSessionId } from "../../helpers";

async function sendAddInventoryItemRequest(itemName: string): Promise<boolean> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}player/item/add`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
            body: JSON.stringify({ itemName }),
        });

        const result: any = await response.json();

        console.log(result);

        if (!result) {
            return false;
        }

        return true;
    } catch (error) {
        console.error(error);
    }
    return false;
}

export default sendAddInventoryItemRequest;
